import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-2" }

import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import { ChevronDownIcon, DocumentDownloadIcon } from '@heroicons/vue/solid';
import { ExportFormat } from '@/utils/spreadsheet';


export default /*@__PURE__*/_defineComponent({
  __name: 'UiExportMenu',
  props: {
    compact: {
        type: Boolean,
        default: false,
    },
    label: {
        type: String,
        default: 'Download',
    },
},
  emits: ["select"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

const selectFormat = (format: ExportFormat) => {
    emit('select', format);
};

return (_ctx: any,_cache: any) => {
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createBlock(_unref(Menu), {
    as: "div",
    class: "relative inline-block text-left"
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_unref(MenuButton), {
        class: _normalizeClass(["hover:text-primary focus:ring-primary inline-flex items-center justify-center bg-white font-medium text-gray-700 shadow ring-1 ring-gray-300 transition hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-opacity-50", __props.compact ? 'h-9 w-9 rounded-full' : 'rounded px-3 py-2 text-sm'])
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DocumentDownloadIcon), {
            class: _normalizeClass(["h-5 w-5 text-gray-500", __props.compact ? '' : '-ml-1 mr-2']),
            "aria-hidden": "true"
          }, null, 8, ["class"]),
          _createElementVNode("span", {
            class: _normalizeClass(__props.compact ? 'sr-only' : '')
          }, _toDisplayString(__props.label), 3),
          (!__props.compact)
            ? (_openBlock(), _createBlock(_unref(ChevronDownIcon), {
                key: 0,
                class: "ml-2 h-4 w-4 text-gray-400",
                "aria-hidden": "true"
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class"])), [
        [_directive_tippy, __props.compact ? __props.label : undefined]
      ]),
      _createVNode(_unref(MenuItems), { class: "absolute right-0 z-20 mt-2 w-64 origin-top-right overflow-hidden rounded bg-white shadow-xl ring-1 ring-gray-300 focus:outline-none" }, {
        default: _withCtx(() => [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "border-b border-gray-100 bg-gray-50 px-4 py-3" }, [
            _createElementVNode("p", { class: "text-sm font-semibold text-gray-800" }, "Escolha o formato"),
            _createElementVNode("p", { class: "text-xs text-gray-500" }, "Baixe os dados em planilha ou texto.")
          ], -1)),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(MenuItem), null, {
              default: _withCtx(({ active }) => [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["flex w-full items-center rounded px-3 py-2 text-left transition", active ? 'bg-gray-100 text-gray-900' : 'text-gray-700']),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (selectFormat('xlsx')))
                }, _cache[2] || (_cache[2] = [
                  _createElementVNode("span", { class: "mr-3 inline-flex h-9 w-12 items-center justify-center rounded bg-emerald-100 text-xs font-bold text-emerald-700" }, " XLSX ", -1),
                  _createElementVNode("span", { class: "min-w-0" }, [
                    _createElementVNode("span", { class: "block text-sm font-semibold" }, "Excel (.xlsx)"),
                    _createElementVNode("span", { class: "block text-xs text-gray-500" }, "Planilha nativa para Excel")
                  ], -1)
                ]), 2)
              ]),
              _: 1
            }),
            _createVNode(_unref(MenuItem), null, {
              default: _withCtx(({ active }) => [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["mt-1 flex w-full items-center rounded px-3 py-2 text-left transition", active ? 'bg-gray-100 text-gray-900' : 'text-gray-700']),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (selectFormat('csv')))
                }, _cache[3] || (_cache[3] = [
                  _createElementVNode("span", { class: "mr-3 inline-flex h-9 w-12 items-center justify-center rounded bg-sky-100 text-xs font-bold text-sky-700" }, " CSV ", -1),
                  _createElementVNode("span", { class: "min-w-0" }, [
                    _createElementVNode("span", { class: "block text-sm font-semibold" }, "CSV"),
                    _createElementVNode("span", { class: "block text-xs text-gray-500" }, "Arquivo leve separado por colunas")
                  ], -1)
                ]), 2)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1,
        __: [4]
      })
    ]),
    _: 1
  }))
}
}

})